import React, { HTMLAttributes } from 'react';
import {
  Container,
  TitleWithText,
} from '@uncinc/uncinc-react-kitchen-sink';
import { Profile } from '@uncinc/react-drupal-core';

import type {
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';

import { ButtonWrapper } from '../../../components';

import { ParagraphPersons as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphPersonsProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphPersons: React.FC<ParagraphPersonsProps> = ({
  entity,
}) => {
  const paragraph = entity.toJS();

  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.processed;
  const persons = paragraph.field_persons;
  const link = paragraph.field_link[0];
  const linkTitle = link?.title;
  const linkUrl = link?.alias ?? link?.uri;

  return (
    <div className="Paragraph ParagraphPersons">
      <Container>
        {(title || body) && (
          <div className="row">
            <div className="col-12 col-md-10 col-lg-8">
              <TitleWithText
                className="text--large"
                title={title}
                text={body}
              />
              {(linkUrl) && (
                <ButtonWrapper
                  href={linkUrl}
                >
                  {linkTitle}
                </ButtonWrapper>
              )}
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-12">
            <ul className="ParagraphPersons__persons">
              {persons.map((person) => {
                const id = person.target_id;
                const uuid = person.target_uuid;
                const key = `${uuid}`;

                return (
                  <li>
                    <Profile
                      key={key}
                      id={id}
                      viewMode="teaser"
                    />
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphPersons;
